<template>
  <transition name="kylin-tip-fade">
    <div v-if="visible" class="kylin-tip-mask" @click.self="handleClose">
      <div class="kylin-tip-panel">
        <button
          type="button"
          class="kylin-tip-close"
          aria-label="close"
          @click="handleClose"
        ></button>

        <div class="kylin-tip-header">
          <h3 class="kylin-tip-title">{{ $t("m100.n1") }}</h3>
        </div>

        <div class="kylin-tip-body">
          <p class="kylin-tip-message">{{ $t("m100.kylin_install_tip") }}</p>
          <a
            class="kylin-tip-link"
            :href="guideUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>{{ $t("m100.kylin_install_how") }}</span>
          </a>
        </div>

        <div class="kylin-tip-footer">
          <button
            type="button"
            class="kylin-tip-btn kylin-tip-btn-primary"
            :disabled="!packageData || !packageData.url"
            @click="handleDownload"
          >
            {{ downloadText }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "KylinInstallTip",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    packageData: {
      type: Object,
      default: null,
    },
    downloadLabel: {
      type: String,
      default: "",
    },
    guideUrl: {
      type: String,
      default:
        "https://minio.oceanbluecloud.com/attachment/麒麟统信允许安装第三方软件.pdf",
    },
  },
  computed: {
    downloadText() {
      const baseText = this.$t("m100.download");
      return this.downloadLabel
        ? `${baseText} (${this.downloadLabel})`
        : baseText;
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handleDownload() {
      if (!this.packageData || !this.packageData.url) {
        return;
      }

      const link = document.createElement("a");
      link.href = this.packageData.url;
      link.download = this.packageData.name;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      this.$emit("download");
      this.handleClose();
    },
  },
};
</script>

<style scoped>
.kylin-tip-mask {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(2px);
}

.kylin-tip-panel {
  position: relative;
  width: 100%;
  max-width: 480px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.16);
  overflow: hidden;
}

.kylin-tip-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent url("../assets/images/download/close.png") center /
    cover no-repeat;
  cursor: pointer;
  z-index: 1;
}

.kylin-tip-header {
  padding: 36px 32px 24px;
  text-align: center;
  background: linear-gradient(
    180deg,
    rgba(0, 163, 209, 0.12) 0%,
    rgba(0, 163, 209, 0) 100%
  );
}

.kylin-tip-title {
  margin: 0;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #222222;
}

.kylin-tip-body {
  padding: 0 32px 8px;
  text-align: center;
}

.kylin-tip-message {
  margin: 0 0 20px;
  font-size: 16px;
  line-height: 1.7;
  color: #666666;
}

.kylin-tip-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  font-weight: 500;
  color: #00a3d1;
  text-decoration: none;
  transition: opacity 0.2s ease;
}

.kylin-tip-link:hover {
  opacity: 0.85;
}

.kylin-tip-footer {
  padding: 24px 32px 32px;
  text-align: center;
}

.kylin-tip-btn {
  min-width: 180px;
  height: 44px;
  padding: 0 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease, opacity 0.2s ease;
}

.kylin-tip-btn-primary {
  background: #00a3d1;
  color: #ffffff;
}

.kylin-tip-btn-primary:hover:not(:disabled) {
  background: #0092bc;
}

.kylin-tip-btn-primary:active:not(:disabled) {
  transform: scale(0.98);
}

.kylin-tip-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.kylin-tip-fade-enter-active,
.kylin-tip-fade-leave-active {
  transition: opacity 0.25s ease;
}

.kylin-tip-fade-enter-active .kylin-tip-panel,
.kylin-tip-fade-leave-active .kylin-tip-panel {
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.kylin-tip-fade-enter,
.kylin-tip-fade-leave-to {
  opacity: 0;
}

.kylin-tip-fade-enter .kylin-tip-panel,
.kylin-tip-fade-leave-to .kylin-tip-panel {
  transform: translateY(12px) scale(0.98);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/KylinInstallTip.vue